import content from "../content/yhteystiedot";
import siteConfig from "../lib/siteConfig";
import Meta from "../components/Meta";
import StructuredData from "../components/StructuredData";
import Address from "../components/Address";
import Hours from "../components/Hours";
import RichText from "../components/RichText";
import Icon from "../components/Icon";
import PreviewBanner from "../components/PreviewBanner";
import Button from "../components/Button";
import { formatPhoneNumber } from "../components/phoneUtils.js";

import { getCompanyInfo } from "../lib/queries/getCompanyInfo";
import { getPageContent } from "../lib/queries/getPageContent";

export default function Ajanvaraus({ companyInfo, pageContent, preview }) {
  //const cleanedNumber = formatPhoneNumber(companyInfo.phone);
  return (
    <>
      <Meta pageContent={pageContent} />
      <StructuredData />
      <div id="content">
        {preview && <PreviewBanner />}
        {pageContent.hero && (
          <section>
            <HeroSection content={pageContent.hero} />
          </section>
        )}
        <section className="page-section page-content page-width page-width--narrow">
          {!pageContent.hero && (
            <h1 className="page-heading">{pageContent.title}</h1>
          )}
          <RichText
            className="mb-4 md:text-lg text-block"
            value={pageContent.introText}
          />
          <div className="md:flex w-full gap-y-4 gap-x-8">
            <div className="md:flex-1 mb-8 md:pt-4">
              <div className="flex flex-col gap-3">
                {companyInfo?.bookingUrl && (
                  <Button
                    className="flex gap-2 items-center"
                    href={`${companyInfo.bookingUrl}`}
                  >
                    <Icon name="calendar" />
                    <span>Varaa aika netistä</span>
                  </Button>
                )}
                {companyInfo?.phone && (
                  <Button
                    variant="secondary"
                    className="flex gap-2 items-center"
                    href={`tel:${formatPhoneNumber(companyInfo.phone)}`}
                  >
                    <Icon name="phone" />
                    {companyInfo.phone}
                  </Button>
                )}
                {companyInfo?.email && (
                  <Button
                    variant="secondary"
                    className="flex gap-2 items-center"
                    href={`mailto:${companyInfo.email}`}
                  >
                    <Icon name="mail" />
                    {companyInfo.email}
                  </Button>
                )}
              </div>
            </div>
            <div className="md:flex-1">
              <div className="p-4"></div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export async function getServerSideProps({ preview = false }) {
  const [companyInfo, pageContent] = await Promise.all([
    getCompanyInfo(preview),
    getPageContent("ajanvaraus", preview),
  ]);
  console.log("📄 fetched pageContent:", pageContent.introText);
  return {
    props: {
      companyInfo,
      pageContent,
      preview,
    },
    //revalidate: siteConfig.revalidate,
  };
}
